export default {
  TOGGLE_SHOW_MODAL(state) {
    state.showModal = !state.showModal;
  },
  SET_SHOW_MODAL_VALIE(state, value) {
    state.showModal = value;
  },
}